/** WCAG relative luminance for an sRGB hex colour. */
export function luminance(hex: string): number {
  const m = hex.replace('#', '')
  const full =
    m.length === 3
      ? m
          .split('')
          .map((c) => c + c)
          .join('')
      : m
  const channel = (i: number) => {
    const v = parseInt(full.slice(i * 2, i * 2 + 2), 16) / 255
    return v <= 0.04045 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4
  }
  return 0.2126 * channel(0) + 0.7152 * channel(1) + 0.0722 * channel(2)
}

export function contrast(a: string, b: string): number {
  const [x, y] = [luminance(a), luminance(b)].sort((p, q) => q - p)
  return (x + 0.05) / (y + 0.05)
}

/**
 * Foreground for text/icons sitting *on* the accent.
 *
 * This has to be derived, not themed: `--accent` is user-chosen and shared
 * across light and dark, so a fixed per-theme value breaks the moment someone
 * picks a dark accent (dark text on dark blue) or a pale one (white on butter).
 */
export function onAccent(accent: string): string {
  const dark = '#17161a'
  const light = '#ffffff'
  return contrast(accent, light) >= contrast(accent, dark) ? light : dark
}
